import { Locate } from 'lucide-react';
import { Box, Divider, HStack, Text } from '@chakra-ui/react';

import { Controller } from '@context';
import { ControllerAutoZoomSupport } from '@features/zoom/types/controller-autozoom-support.type';
import { useDesign } from '@hooks';
import { useSubscription } from '@rta/rta-blueprint-library';
import { RtaFeatureIconButton, RtaIconButton } from '@components';
import { useZoomInFeature, useZoomOutFeature } from '@features';

export const NavigationControls = () => {
	const [controller] = useDesign<Controller, ControllerAutoZoomSupport>();

	const zoomOut = useZoomOutFeature();
	const zoomIn = useZoomInFeature();

	useSubscription(controller, false, [['viewport-state', 'updated']]);

	const zoom = controller?.viewport?.state?.zoom ?? null;
	// console.log('NavigationControls', controller?.viewport?.state?.zoom);

	return (
		<Box w={'100%'} h={'100%'} m={'1px'} border={'0px'}>
			<HStack h={'100%'} gap={'5px'}>
				<RtaIconButton enabled={false} icon={<Locate/>} label="Center" height="26px"/>
				<Divider orientation={'vertical'} ml="5px"/>
				<RtaFeatureIconButton feature={zoomOut} />
				<Text fontSize="lg" as="b" width={'70px'}
					textAlign="center" verticalAlign={'middle'}
				>{zoom === null || !Number.isFinite(zoom) ? '---' : `${(zoom * 100).toFixed(0)}%`}</Text>
				<RtaFeatureIconButton feature={zoomIn} />
			</HStack>
		</Box>
	);
};
